import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { WorkflowDetailModel } from '../../models/workflows/workflow-detail.model';
import { WorkflowService } from '../../services/workflow.service';


@Injectable({ providedIn: 'root' })
export class WorkflowDetailResolver  {
  constructor(private workflowService: WorkflowService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<WorkflowDetailModel> | Promise<WorkflowDetailModel> | WorkflowDetailModel {

    const workflowId = route.params.id;

    return this.workflowService.getWorkflowDetailById(workflowId).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(err: HttpErrorResponse | any) {
    console.error('An error occurred', err);
    return throwError(err.message || err);
  }
}
